import { render, staticRenderFns } from "./SidebarLeftOld.vue?vue&type=template&id=f753b8f8&scoped=true&"
import script from "./SidebarLeftOld.vue?vue&type=script&lang=js&"
export * from "./SidebarLeftOld.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLeftOld.vue?vue&type=style&index=0&id=f753b8f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753b8f8",
  null
  
)

export default component.exports